import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=e5f0b090&scoped=true&"
import script from "./SignupPage.vue?vue&type=script&lang=js&"
export * from "./SignupPage.vue?vue&type=script&lang=js&"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=e5f0b090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f0b090",
  null
  
)

export default component.exports